export default __webpack_public_path__ + "static/media/logo-psychflex-full.bf0f2d4f.png";